/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { PatchProjectsProjectidOptions, PatchProjectsProjectidStatus200, PatchProjectsProjectidStatus400, PatchProjectsProjectidStatus401, PatchProjectsProjectidStatus404, PatchProjectsProjectidStatus500 } from '../types/PatchProjectsProjectid'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { patchProjectsProjectid } from '../clients/patchProjectsProjectid'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const patchProjectsProjectidMutationKey = () => [{ url: '/projects/:projectId' }] as const

export function patchProjectsProjectidMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = patchProjectsProjectidMutationKey()
  return mutationOptions<PatchProjectsProjectidStatus200, ResponseErrorConfig<PatchProjectsProjectidStatus400 | PatchProjectsProjectidStatus401 | PatchProjectsProjectidStatus404 | PatchProjectsProjectidStatus500>, PatchProjectsProjectidOptions, TContext>({
    mutationKey,
    mutationFn: async({ path, body }) => {
      return patchProjectsProjectid({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * {@link /projects/:projectId}
 */
export function usePatchProjectsProjectid<TContext>(options: {
  mutation?: UseMutationOptions<PatchProjectsProjectidStatus200, ResponseErrorConfig<PatchProjectsProjectidStatus400 | PatchProjectsProjectidStatus401 | PatchProjectsProjectidStatus404 | PatchProjectsProjectidStatus500>, PatchProjectsProjectidOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? patchProjectsProjectidMutationKey()

  const baseOptions = patchProjectsProjectidMutationOptions(config) as UseMutationOptions<PatchProjectsProjectidStatus200, ResponseErrorConfig<PatchProjectsProjectidStatus400 | PatchProjectsProjectidStatus401 | PatchProjectsProjectidStatus404 | PatchProjectsProjectidStatus500>, PatchProjectsProjectidOptions, TContext>

  return useMutation<PatchProjectsProjectidStatus200, ResponseErrorConfig<PatchProjectsProjectidStatus400 | PatchProjectsProjectidStatus401 | PatchProjectsProjectidStatus404 | PatchProjectsProjectidStatus500>, PatchProjectsProjectidOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<PatchProjectsProjectidStatus200, ResponseErrorConfig<PatchProjectsProjectidStatus400 | PatchProjectsProjectidStatus401 | PatchProjectsProjectidStatus404 | PatchProjectsProjectidStatus500>, PatchProjectsProjectidOptions, TContext>
}
